module.exports = __webpack_public_path__ + "img/chest.2b075273.webp";